// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-085c1b15]{display:none}.slider[data-v-085c1b15]{-ms-overflow-style:none;scrollbar-width:none}.slider[data-v-085c1b15]::-webkit-scrollbar{display:none}.desktop-service-card[data-v-085c1b15]{flex-shrink:0;flex-grow:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
